import {updateManyPropertyNotes} from 'ducks/propertyNotes';
import AnalyticsGateway from 'lib/AnalyticsGateway';
import {updatePropertyPreferences} from 'api/propertyPreferences';
import {
  addComparableItem,
  deleteComparableItemImage,
  featureItem,
  fetchComparableItems,
  getPage,
  moveSelectedItem,
  orderSelectedItem,
  removeFeatureItem,
  resetComparableItemFields,
  setDisplayItemField,
  updateComparableItemFetching,
  updateSelectAllItems,
  uploadComparableItemImage
} from 'actionCreators/comparableItems';
import {getComparableListings} from 'api/ComparablesApi';
import { COMPARABLE_TYPE } from '../constants/comparableTypes';

export const UPDATE = 'pulp/comparableListings/UPDATE';
export const ADD_SELECTED = 'pulp/comparableListings/ADD_SELECTED';
export const MOVE_SELECTED = 'pulp/comparableListings/MOVE_SELECTED';
export const ORDER_SELECTED = 'pulp/comparableListings/ORDER_SELECTED';
export const REMOVE_SELECTED = 'pulp/comparableListings/REMOVE_SELECTED';
export const UPDATE_SORT_BY = 'pulp/comparableListings/UPDATE_SORT_BY';
export const LOAD_MORE = 'pulp/comparableListings/LOAD_MORE';
export const ADD_COMPARABLE = 'pulp/comparableListings/ADD_COMPARABLE';
export const UPDATE_SUGGESTED = 'pulp/comparableListings/UPDATE_SUGGESTED';
export const SELECT_ALL = 'pulp/comparableListings/SELECT_ALL';
export const DESELECT_ALL = 'pulp/comparableListings/DESELECT_ALL';
export const UPDATE_ATTRIBUTE = 'pulp/comparableListings/UPDATE_ATTRIBUTE';
export const FEATURE_PROPERTY = 'pulp/comparableListings/FEATURE_PROPERTY';
export const REMOVE_FEATURE_PROPERTY = 'pulp/comparableListings/REMOVE_FEATURE_PROPERTY';
export const SET_DISPLAY_FIELD = 'pulp/comparableListings/SET_DISPLAY_FIELD';
export const RESET_COMPARABLE = 'pulp/comparableListings/RESET_COMPARABLE';
export const UPDATE_ITEM_FETCHING = 'pulp/comparableListings/UPDATE_ITEM_FETCHING';

export function updateForSession(payload, savePreference = false) {
  return (dispatch, getState) => {
    if (savePreference) {
      const {propertyDetail: {propertyId: targetPropertyId}} = getState();
      updatePropertyPreferences(targetPropertyId, {
        [`comparableListings.properties.${payload.propertyId}:${JSON.stringify(payload.keyPath)}`]: payload,
      });
    }

    return dispatch({type: UPDATE_ATTRIBUTE, payload});
  };
}

export function updateItems(payload) {
  return {type: UPDATE, payload};
}

export function addSelectedItem(propertyId) {
  return (dispatch, getState) => {
    const {
      propertyDetail: {propertyId: targetPropertyId},
      comparableListings: {selected},
      comparableListings: {featured}
    } = getState();

    updatePropertyPreferences(targetPropertyId, {
      'comparableListings.selected': addComparableItem(propertyId, selected, featured),
    });

    dispatch({type: ADD_SELECTED, payload: propertyId});
  };
}

export function removeSelectedItem(propertyId) {
  return (dispatch, getState) => {
    const {
      propertyDetail: {propertyId: targetPropertyId},
      comparableListings: {selected},
      reportType
    } = getState();
    const newSelected = selected.filter((s) => s !== propertyId);

    updatePropertyPreferences(targetPropertyId, {
      'comparableListings.selected': newSelected,
    });

    if (!newSelected.length) {
      updatePropertyPreferences(targetPropertyId, {
        'comparableListings.selectedMoved': false,
      });
    }
    AnalyticsGateway.sendEvent({
      eventName: 'Remove Comparable',
      properties: [
        {label: 'Page', value: getPage(reportType, COMPARABLE_TYPE.LISTINGS)}
      ]
    });

    dispatch({type: REMOVE_SELECTED, payload: propertyId});
  };
}

export function updateSortBy(sortBy, savePreference = false) {
  return (dispatch, getState) => {
    if (savePreference) {
      const {propertyDetail: {propertyId}} = getState();
      updatePropertyPreferences(propertyId, {'comparableListings.sortBy': sortBy});
    }

    dispatch({type: UPDATE_SORT_BY, payload: sortBy});
  };
}

export function loadMore() {
  return {type: LOAD_MORE};
}

export function addItem(data, featureFlags = {}) {
  return {type: ADD_COMPARABLE, payload: data, flags: featureFlags};
}

export function updateSuggestedItems() {
  return {type: UPDATE_SUGGESTED};
}

export function fetchItem(propertyId, savePreference = false) {
  return async (dispatch, getState) => {
    const {propertyDetail: {propertyId: targetPropertyId, latitude, longitude}, comparableListings: {selected}} = getState();
    const {propertyNotes, ...data} = await getComparableListings(targetPropertyId, propertyId, latitude, longitude);
    const {featureFlags} = getState();
    dispatch(addItem(data, featureFlags));
    dispatch(updateManyPropertyNotes({[data.propertyId]: propertyNotes}));

    if (savePreference) {
      updatePropertyPreferences(targetPropertyId, {
        'comparableListings.selected': [propertyId, ...selected],
      });
    }
  };
}

export const featureProperty = (...args) => featureItem(COMPARABLE_TYPE.LISTINGS)(...args);

export const removeFeatureProperty = (...args) => removeFeatureItem(COMPARABLE_TYPE.LISTINGS)(...args);

export const updateSelectAll = (...args) => updateSelectAllItems(COMPARABLE_TYPE.LISTINGS)(...args);

export const moveSelected = (...args) => moveSelectedItem(COMPARABLE_TYPE.LISTINGS)(...args);

export const orderSelected = (...args) => orderSelectedItem(COMPARABLE_TYPE.LISTINGS)(...args);

export const fetchItems = (...args) => fetchComparableItems(COMPARABLE_TYPE.LISTINGS)(...args);

export const uploadComparableImage = (...args) => uploadComparableItemImage(COMPARABLE_TYPE.LISTINGS)(...args);

export const deleteUploadedImage = (...args) => deleteComparableItemImage(COMPARABLE_TYPE.LISTINGS)(...args);

export const setDisplayField = (...args) => setDisplayItemField(COMPARABLE_TYPE.LISTINGS)(...args);

export const resetComparableProperty = (...args) => resetComparableItemFields(COMPARABLE_TYPE.LISTINGS)(...args);

export const updateFetching = (...args) => updateComparableItemFetching(COMPARABLE_TYPE.LISTINGS)(...args);
